// General import
import React, { useState, useRef, Validator } from 'react'
import { ReactElementLike } from 'prop-types'
import { Modal,Button, NavDropdown,Toast, Popover, Form,ButtonGroup,Pagination} from 'react-bootstrap'
import parse from 'html-react-parser'
import { Card,Col} from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import {loginOut} from './components/Login/LoginFunctions'

// import { AFMSankeyNode,AFMSankeyLink,/*AFMSankeyData,*/SankeyData,SankeyNode,SankeyLink } from './types'
// Import from local files
import { SuiteSankeyNode,SuiteSankeyLink,SuiteSankeyData,SuiteSankeyLinkValue } from './types'
import i18next from './traduction'
import {SankeySuiteDialogSaveJSON} from './SankeySuiteDialogSaveJSON'

// Import From AFM
import SupplyUseModelisationProd from 'afmsankey/dist/SankeyReconciliation'
import {afm_menu_configuration_import_export,SplitVerticalModal,processTrade,additional_selector,afm_edition_menu} from 'afmsankey/dist/AFMSankeyMenu'
import {FreeVariables} from 'afmsankey/dist/FreeVariables'

// Import from opensankey
import Menu, { OpenSankeyMenus,OpenSankeyModalWelcome } from 'open-sankey/dist/SankeyMenu'
import { ExempleItem } from 'open-sankey/dist/SankeyMenuExamples'
import { SankeySettingsEditionElementTags } from 'open-sankey/dist/SankeyMenuConfigurationTags'
import * as OpenSankeyUtils from 'open-sankey/dist/SankeyUtils'
import {OpenSankeyConfigurationsMenus} from 'open-sankey/dist/SankeyMenuConfiguration'
import { OpenSankeyMenuConfigurationLayout } from 'open-sankey/dist/SankeyMenuConfigurationLayout'
import {OpenSankeyConfigurationNodesAttributes} from 'open-sankey/dist/SankeyMenuConfigurationNodesAttributes'
import {OpenSankeyMenuConfigurationNodes} from 'open-sankey/dist/SankeyMenuConfigurationNodes'
import {OpenSankeyMenuConfigurationLinks} from 'open-sankey/dist/SankeyMenuConfigurationLinks'
import {OpenSankeyMenuConfigurationLegend} from 'open-sankey/dist/SankeyMenuConfigurationLegend'
import {OpenSankeyMenuBanner,toolbar_builder,addAllDropDownNode,addSimpleLevelDropDown,setDiagram} from 'open-sankey/dist/SankeyMenuBanner'
import ModalPreference,{OpenSankeyDefaultModalePreferenceContent,preferenceCheck} from 'open-sankey/dist/SankeyMenuPreferences'
import { keyHandler } from 'open-sankey/dist/SankeyDraw'



// Import Form SankeyPlus
import * as SankeyViews from 'sankeyanimation/dist/SankeyPlusViews'
import { SankeyPlusNodesAttributes,SankeyPlusNodeIcon } from 'sankeyanimation/dist/SankeyPlusNodes'
import {SankeyPlusModalStyleLink,SankeyPlusModalStyleNode} from 'sankeyanimation/dist/SankeyPlusStyle'
import {SankeyPlusMenuConfigurationFreeLabels,SankeyPlusMenuPreferenceLabels} from 'sankeyanimation/dist/SankeyPlusMenuConfigurationLabels'
import * as SankeyPlusGradient from 'sankeyanimation/dist/SankeyPlusGradient'
import {SankeyPlusShortcut} from 'sankeyanimation/dist/SankeyPlusItemShortcut'
import { SankeyPlusLabel } from 'sankeyanimation/src/types'
import { SankeyPlusNodeFO} from 'sankeyanimation/dist/SankeyPlusForeignObject'


// Import From sankeyDev
import {PublishModal,SankeyDevMenuPublishItem} from 'sankeydev/dist/PublishModale'
import {MenuConfigHideLoneNode} from 'sankeydev/dist/HideLoneNodeFunction'
import {itemDemo} from 'sankeydev/dist/MenuExampleDemo'
import {SankeyDevMenuDataPercent} from 'sankeydev/dist/PercentValue'
import {MenuEnregistrerExcelSimple} from 'sankeydev/dist/MenuEnregistrerExcelSimple'
import {SankeyDev_mode_Construction_Visualisation} from 'sankeydev/dist/ItemMenuPrefernce'


declare const window: Window &
typeof globalThis & {
  SankeyToolsStatic: boolean
  sankey: {
    sankey_data_file:RequestInfo
    sous_filieres : { [ key : string ] : string }
    units: string[]
    flask_logo? : string
    flask_header? : string
    logo_width? : number
    legend_average : string
    legend_uncert : string
    help_text : string
    welcome_text: string
    excel : string
    logo: string,
    advanced: boolean,
    intro: string
  }
}

type SankeyMenuTypes = {
  data: SuiteSankeyData,
  set_data: (d:SuiteSankeyData)=>void,
  get_default_data:()=>SuiteSankeyData,
  displayed_value: string,
  set_displayed_value: (s:string)=>void,
  set_animating: (b:boolean)=>void,
  multi_selected_nodes: {current : SuiteSankeyNode[]}
  multi_selected_links: {current : SuiteSankeyLink[]}
  multi_selected_label: {current : SankeyPlusLabel[]}
  selected_node: {current : SuiteSankeyNode},
  selected_link: {current : SuiteSankeyLink},
  button_ref: {current : HTMLLabelElement| null},
  accordion_ref: {current : HTMLDivElement| null},
  links_accordion_ref: {current : HTMLDivElement| null},
  nodes_accordion_ref: {current : HTMLDivElement| null},
  exemple_menu        : object,
  formations_menu      : object,
  logo: string,
  logo_terriflux: string,
  token: boolean,
  has_sankey_suite: boolean,
  has_open_sankey_plus: boolean,
  has_sankeydev:boolean,
  unsetTokens: ()=>void,
  useNavigate:()=>any,
  mode_selection: {current:string},
  user_scale:number,
  set_user_scale:(n:number)=>void,
  SuiteGetLinkValue:(data: SuiteSankeyData, idLink: string, up?: boolean) => SuiteSankeyLinkValue,
  tags_selected: {[k: string]: string},
  set_tags_selected: (o:{[k: string]: string})=>void,
  current_data:SuiteSankeyData | undefined,
  set_current_data:(d:SuiteSankeyData)=>void,
  reinitialization:()=>void,
  selected_style_node:string,
  set_selected_style_node:(s:string)=>void,
  selected_style_link:string,
  set_selected_style_link:(s:string)=>void,
  view:string,
  set_view:(s:string)=>void,
  first_selected_node:object,
  set_first_selected_node:(o:object)=>void,
  show_toast_limit_node:boolean,
  set_show_toast_limit_node:(b:boolean)=>void,
  size_of_draw_zone:(d:SuiteSankeyData)=>number[],
  name_user:string
}


export const SankeySuiteMenu = ({
  data,
  set_data,
  get_default_data,
  displayed_value,
  set_displayed_value,
  set_animating,
  multi_selected_nodes,
  multi_selected_links,
  multi_selected_label,
  selected_node,
  selected_link,
  button_ref,
  accordion_ref,
  links_accordion_ref,
  nodes_accordion_ref,
  exemple_menu,
  formations_menu,
  logo,
  logo_terriflux,
  token,
  has_sankey_suite,
  has_open_sankey_plus,
  has_sankeydev,
  unsetTokens,
  useNavigate,
  mode_selection,
  user_scale,
  set_user_scale,
  SuiteGetLinkValue,
  tags_selected,
  set_tags_selected,
  current_data,
  set_current_data,
  reinitialization,
  selected_style_node,
  set_selected_style_node,
  selected_style_link,
  set_selected_style_link,
  view,
  set_view,
  first_selected_node,
  set_first_selected_node,
  show_toast_limit_node,
  set_show_toast_limit_node,
  size_of_draw_zone,
  name_user
} : SankeyMenuTypes) => {



    const [nav_item_active, set_nav_item_active] = useState<string>('')
    const [style_to_apply, set_style_to_apply] = useState('default')
    const [show_modal_welcome,set_show_modal_welcome]=useState(true)
    const [never_see_again,set_never_see_again]=useState((localStorage.getItem('dontSeeAggainWelcome')==='1'))

    // For OpenSankeyConfigurationsMenus
    const [sub_nav_item_active, set_sub_nav_item_active] = useState<string>('')
    const [show_nav,set_show_nav] = useState(false)



    //For OpenSankeyMenuConfigurationLegend
    const [legend_position, set_legend_position] = useState(data.legend_position)

    // For OpenSankeyMenuConfigurationLayout
    const [maximum_flux, set_maximum_flux] = useState(data.maximum_flux)
    const [node_hspace, set_node_hspace] = useState(data.h_space)
    const [node_vspace, set_node_vspace] = useState(data.v_space)

    // For OpenSankeyMenuConfigurationNodes
    const [link_io,set_link_io]=useState<string>('output')
    const [link_pos,set_link_pos]=useState<string>('right')
    const [tab_colored,set_tab_colored]=useState<boolean>(false)

    // For SankeyPlusMenuConfigurationFreeLabels
    const [forceUpdate, setForceUpdate] = useState(false)

    // For afm_menu_configuration_import_export
    const [trade_close,set_trade_close] = useState(true)

    const [show_load,set_show_load] = useState(false)

    //- Processess
    const [processing,setProcessing] = useState(false)
    const [failure,setFailure] = useState(false)
    const [not_started,setNotStarted] = useState(true)
    const [result,setResult] = useState('')
    const [path,setPath] = useState('')

    //- AFMSankey
    const [show_split_trade_dialog,set_show_split_trade_dialog] = useState(false)
    const action_type = useRef('optim_sankey')
    const [show_reconciliation,set_show_reconciliation] = useState(false)

    //- OpenSankey+
    const [show_toast_new_view, set_show_toast_new_view] = useState(false)
    const [show_toast_update_view, set_show_toast_update_view] = useState(false)
    const [view_not_saved,set_view_not_saved]=useState('')

    // Modals
    const [show_excel_dialog, set_show_excel_dialog] = useState(false)
    const [show_apply_layout, set_show_apply_layout] = useState(false)
    const [show_save_json, set_show_save_json] = useState(false)
    const [showPreference, setShowPreference] = useState(false)

    const [radio_selected] = useState<string>('local')
    const [showStyle, setShowStyle] = useState(false)

    //- Modals and Dialogs
    const [welcome_text,set_welcome_text] = useState(window.sankey ? window.sankey.welcome_text : '')

    // For OpenSankeyMenuConfigurationLinks
    const [tags_group_key, set_tags_group_key] = useState(Object.keys(data.fluxTags).length > 0 ? Object.keys(data.fluxTags)[0] : '')

    // Modal et fonctions pour l'edition et affectation des style de flux
    const [showStyleLink, setShowStyleLink] = useState(false)
    const showStyleEditionLink = () => {
      setShowStyleLink(true)
    }
    const [show_publish_dialog,set_show_publish_dialog] = useState(false)
    const [show_modalTemplate, set_show_modalTemplate] = useState(false)


    // Modal et fonctions pour l'édition et affectation des styles de noeud

    const showStyleEdition = () => {
        setShowStyle(true)
    }

    let url_prefix='/opensankey/'
    if (has_sankey_suite) {
        url_prefix='/sankeytools/'
    }
    // Create traduction function
    const {t} = useTranslation()

    const launch = (path:string) => {
        setPath(path)
        set_show_load(true)
        setProcessing(true)
        setFailure(true)
        setNotStarted(false)
        setResult('')
    }


    const tmp=JSON.parse(JSON.stringify(exemple_menu))
    let list_template_data=[] as string[]
    // Si exemple_menu contient OpenSankey et que ce sous dossier contient les templates simple alors remple la liste des templates avec les modèle simples
    if(Object.keys(tmp).length!==0 && Object.keys(tmp).includes('OpenSankey') && Object.keys(tmp['OpenSankey']).includes('easy_template') ){
        list_template_data=tmp['OpenSankey']['easy_template'].filter((f:string)=>!f.includes('.xlsx'))
    // Si l'un des sous dossier d'OpenSankey dans exemple_menu est expert_template alors ajoute les modèles expert à la liste des modèles
        if( token && Object.keys(tmp['OpenSankey']).includes('expert_template') ){
        list_template_data.push(tmp['OpenSankey']['expert_template'])
        list_template_data=list_template_data.flat()
        }
    }

    const cardsTemplate=
    <>
        {list_template_data.map((_,idx) =>
        {
        const title=_.split('.').splice(0,1).join('')
        return(
            <Col key={idx}>
            <Card>
                <Card.Img className='img-card' variant="top" src={'/fm/userfiles/OpenSankey/image_preview/'+title+'.png'} style={{'objectFit':'contain','minHeight':'350px','maxHeight':'500px'}} />
                <Card.Body>
                <Card.Title>{title.replaceAll('_',' ')}</Card.Title>
                <Card.Text>

                </Card.Text>
                <ButtonGroup>
                    <Button variant='primary'
                    onClick={() => {
                        multi_selected_nodes.current = []
                        multi_selected_links.current = []
                        multi_selected_label.current = []
                        const difficulty_file=(tmp['OpenSankey']['easy_template'].includes(list_template_data[idx]))?'easy_template':'expert_template'
                        OpenSankeyUtils.uploadExemple(
                        'OpenSankey/'+difficulty_file+'/'+list_template_data[idx], url_prefix, data, set_data,reinitialization,set_user_scale
                        )
                        set_data({...data})
                    }

                    }
                    >{t('useTemplate')}</Button>
                    <Button variant='info'
                    onClick={() => {
                        multi_selected_nodes.current = []
                        multi_selected_links.current = []
                        multi_selected_label.current = []
                        const difficulty_file=(tmp['OpenSankey']['easy_template'].includes(list_template_data[idx]))?'easy_template':'expert_template'
                        OpenSankeyUtils.downloadExempleExcel(
                        'OpenSankey/'+difficulty_file+'/'+list_template_data[idx]
                        )
                    }

                    }
                    >{t('dl')}</Button>
                </ButtonGroup>
                </Card.Body>
            </Card>
            </Col>
        )})}
    </>

    const additional_shortcut_item=[] as JSX.Element[]
    additional_shortcut_item.push(SankeyPlusShortcut())


    const [active_page,set_active_page]=useState('intro')
    const intro=<div>
        <img src='/fm/userfiles/OpenSankey/image_carousel/intro.png' alt='intro carousel' style={{'objectFit':'contain','width':'100%'}}/>
        <p>{t('Banner.hlp_1_txt_1')}</p>
        <ol>
        <li>{t('welcome.1')}</li>
        <li>{t('welcome.2')}</li>
        <li>{t('welcome.3')}</li>
        <li>{t('welcome.4')}</li>
        <li>{t('welcome.5')}</li>
        <li>{t('welcome.6')}</li>
        <li>{t('welcome.7')}</li>
        <li>{t('welcome.8')}</li>
        <li>{t('welcome.9')}</li>
        <li>{t('welcome.10')}</li>
        </ol>
    </div>
    let src_intro_static = 'intro_static.png'
    if (window.sankey.intro) {
        src_intro_static = window.sankey.intro
    }
    const intro_static=<div>
        <img src={src_intro_static} alt='intro carousel' style={{'objectFit':'contain','width':'100%'}}/>
        <p>{t('Banner.hlp_1_txt_1')}</p>
    </div>    

    const pagination_intro=<Pagination.Item active={active_page==='intro'} key={'intro'} onClick={()=>{
        set_active_page('intro')
        }}>Introduction
    </Pagination.Item>

    const external_pagination=[pagination_intro]
    const external_content={'intro': window.SankeyToolsStatic ? intro_static : intro}

    const intro_modal=OpenSankeyModalWelcome(t,active_page,set_active_page,(welcome_text == undefined || welcome_text =='') && show_modal_welcome,set_show_modal_welcome,never_see_again,set_never_see_again,[],external_pagination,external_content,exemple_menu)



    //- 1. Builds Configuration Menus
    //- 1.1 Builds Configuration Menus Layout
    let  menu_configuration_layout= OpenSankeyMenuConfigurationLayout(t,data,set_data,user_scale,set_user_scale,maximum_flux,set_maximum_flux,node_hspace,set_node_hspace,node_vspace,set_node_vspace)

    //- 1.2 Builds Configuration Menus Node
    //- 1.2.1 Builds Configuration Menus Node Attributes
    let menu_configuration_nodes_attributes = OpenSankeyConfigurationNodesAttributes(t,data,set_data,multi_selected_nodes,false,selected_style_node)

    menu_configuration_nodes_attributes = menu_configuration_nodes_attributes.concat(SankeyPlusNodesAttributes(t,data,set_data,multi_selected_nodes,has_open_sankey_plus))

    if(has_sankeydev){
        menu_configuration_nodes_attributes = menu_configuration_nodes_attributes.concat(MenuConfigHideLoneNode(t,data,set_data,multi_selected_nodes))
    }

    //- 1.2.2 Builds Configuration Menus Node
    const menu_configuration_nodes = OpenSankeyMenuConfigurationNodes(t,data,set_data,multi_selected_nodes,menu_configuration_nodes_attributes,link_io,set_link_io,link_pos,set_link_pos,tab_colored,set_tab_colored,SuiteGetLinkValue)


    menu_configuration_nodes['icon']=SankeyPlusNodeIcon(t,data,set_data,multi_selected_nodes,radio_selected,has_open_sankey_plus)
    menu_configuration_nodes['fo']=SankeyPlusNodeFO(t,data,set_data,multi_selected_nodes,has_open_sankey_plus)
    //- 1.2.3 Builds Configuration Menus Node Tags
    const menu_configuration_nodes_tags=<SankeySettingsEditionElementTags
        t={t}
        data={data}
        set_data={set_data}
        elementTagNameProp='nodeTags'
        elementNameProp='nodes' />

    //- 1.3 Builds Configuration Menus Links
    //- 1.3.1.1 Builds different subpart for Menu Links according to activated token
    const additional_data_element=[]
    const add_link_appearence_item=[] as JSX.Element[]
    if (has_sankey_suite) {
        additional_data_element.push(FreeVariables(data,set_data,multi_selected_links,tags_selected,selected_link))
    }
    if(has_sankeydev){
        additional_data_element.push(SankeyDevMenuDataPercent(data,set_data,multi_selected_links,tags_selected,selected_link))
    }
    add_link_appearence_item.push(SankeyPlusGradient.menu_conf_link_apparence_gradient(t,multi_selected_links,data,set_data,has_open_sankey_plus))
    //- 1.3.1.2 Builds the core for Menu Links
    const menu_configuration_links = OpenSankeyMenuConfigurationLinks(data,set_data,selected_link,multi_selected_links,t,tags_group_key,set_tags_group_key,tags_selected,set_tags_selected,additional_data_element,displayed_value,set_displayed_value,add_link_appearence_item)

    //- 1.3.2 Builds Configuration Menus Link tags
    const  menu_configuration_link_tags=<SankeySettingsEditionElementTags
        t={t}
        data={data}
        set_data={set_data}
        elementTagNameProp='fluxTags'
        elementNameProp='links' />

    //- 1.4 Builds Configuration Menus DataTags
    const  menu_configuration_data_tags=<SankeySettingsEditionElementTags
        t={t}
        data={data}
        set_data={set_data}
        elementTagNameProp='dataTags'
        elementNameProp='links' />

    //- 1.5 Builds Configuration Menus FreeLabel
    let menu_configuration_free_labels=<></>

    menu_configuration_free_labels=SankeyPlusMenuConfigurationFreeLabels(data,set_data,multi_selected_label,t,forceUpdate,setForceUpdate,nav_item_active,set_nav_item_active,has_open_sankey_plus)

    //- 1.6 Builds Configuration Menus Legend
    const menu_configuration_legends=  OpenSankeyMenuConfigurationLegend(data,set_data,t,legend_position,set_legend_position)

    //- 1.7 Finish builds Configuration Menus
    let configurations_menus =  OpenSankeyConfigurationsMenus(
        t,
        data, set_data,nav_item_active,set_nav_item_active,
        nodes_accordion_ref,links_accordion_ref,
        selected_node,multi_selected_nodes,multi_selected_links,selected_link,
        style_to_apply,set_style_to_apply,set_show_nav,
        menu_configuration_layout,menu_configuration_nodes_tags, menu_configuration_link_tags, menu_configuration_data_tags,
        menu_configuration_nodes,menu_configuration_links,menu_configuration_free_labels,menu_configuration_legends,sub_nav_item_active,set_sub_nav_item_active,
        has_open_sankey_plus,token,set_displayed_value,tags_selected,set_tags_selected
    )
    const _load_json = useRef<HTMLInputElement>(null)
    configurations_menus.splice(4,0,SankeyViews.viewsAccordion(
        data,set_data,nav_item_active,set_nav_item_active,view,set_view,multi_selected_nodes,multi_selected_links,multi_selected_label,current_data,set_current_data,_load_json,t,has_open_sankey_plus,set_view_not_saved
    ))
    //- construct here as hook inside afm_menu_configuration_import_export can not be called inside if.
    if (has_sankey_suite) {
        const the_afm_menu_configuration_import_export = afm_menu_configuration_import_export(data,set_data,nav_item_active,set_nav_item_active,trade_close,set_trade_close)
        configurations_menus.splice(3,0,the_afm_menu_configuration_import_export)
    }
    //- End of 1. Build configuration Menus

    //- 2.  Build Menus
    //- 2.1 Build Menus dropdown
    //- 2.2 Build Menus banner
    //- 2.3 Build Menus toolbar
    let additional_edition_item=[] as JSX.Element[]
    if(has_sankeydev){
        const item_publish=SankeyDevMenuPublishItem(t,set_show_publish_dialog)
        additional_edition_item.push(item_publish)
    }

    let additional_save_item=[] as JSX.Element[]
    if(has_sankeydev){
        const item_save_excel_simple=MenuEnregistrerExcelSimple(url_prefix,data)
        additional_save_item.push(item_save_excel_simple)
    }

    const sankey_menus = OpenSankeyMenus(
        t,setShowPreference,reinitialization,get_default_data,set_show_publish_dialog,set_show_apply_layout,set_show_excel_dialog,
        set_show_save_json,showStyleEdition,showStyleEditionLink,
        set_show_modal_welcome,set_never_see_again,data,set_data,url_prefix,set_show_modalTemplate,additional_edition_item,additional_save_item,set_user_scale
    )
    // Pré-traitement du menu tuto pour trier les groupes
    const n_a=new Array(50)

    Object.keys(formations_menu).map(d=>{
        return d.replace('_','__').split('__')
    }).forEach(element => {
        if(element.length>1){
            n_a[Number(element[0])]=element[0]+'_'+element[1]
        }else{
            n_a[n_a.length-1]=element[0]
        }
    })
    // Return l'objet formations_menu mais trier selon le numéro du groupe (quand il y en a un)
    const new_array_for_exemple=Object.fromEntries(n_a.filter(f=>f).map((d,idx)=>{
        return [d,(formations_menu as {[k:string]:string})[d]]
    }))
    sankey_menus.splice(2,0,<NavDropdown title={t('Menu.Formations')} id={"formation"} key={'formations'}>
        <ExempleItem
        exemple_menu={new_array_for_exemple as unknown as Validator<ReactElementLike> | Validator<{ [x: string]: ReactElementLike; }>}
        data={data}
        set_data={set_data}
        current_path={'Formations'}
        url_prefix={url_prefix}
        multi_selected_links={multi_selected_links}
        multi_selected_nodes={multi_selected_nodes}
        multi_selected_label={multi_selected_label}
        launch={launch}
        reinitialization={reinitialization}
        set_user_scale={set_user_scale}

        /></NavDropdown >
    )
    // sankey_menus.splice(3,0,<NavDropdown title={t('Menu.Exemples')} id="exemples" >
    //   <ExempleItem
    //     exemple_menu={exemple_menu as unknown as Validator<ReactElementLike> | Validator<{ [x: string]: ReactElementLike; }>}
    //     url_prefix={url_prefix}
    //     data={data}
    //     set_data={set_data}
    //     current_path={''}
    //     multi_selected_nodes={multi_selected_nodes}
    //     multi_selected_links={multi_selected_links}
    //     multi_selected_label={multi_selected_label}
    //     launch={launch}
    //   /></NavDropdown >
    // )
    if(has_sankeydev){
        sankey_menus.splice(3,0,itemDemo(t,exemple_menu,url_prefix,data,set_data,multi_selected_nodes,multi_selected_links,multi_selected_label,launch,reinitialization,set_user_scale))
    }
    if (has_sankey_suite) {
        sankey_menus.splice(2,0,afm_edition_menu(data,set_show_split_trade_dialog,action_type,set_show_reconciliation))
    }

    // 2.4 Modal linked to menu item
    const external_menu_modal=[] as JSX.Element[]
    const regular_ui=OpenSankeyDefaultModalePreferenceContent(t,data,set_data,i18next)
    const modale_style_link=<React.Fragment key={'modale_style_link'}>{SankeyPlusModalStyleLink(t,data,set_data,showStyleLink,setShowStyleLink,selected_link,selected_style_link,set_selected_style_link,has_open_sankey_plus,add_link_appearence_item)}</React.Fragment>
    const modale_style_node=<React.Fragment key={'modale_style_node'}>{SankeyPlusModalStyleNode(t,data,set_data,showStyle,setShowStyle,selected_style_node,set_selected_style_node,has_open_sankey_plus)}</React.Fragment>

    // Warning when we try to create node with mouse click and we have exceeded the number for unconnected user
    const toast_warning_limit_node=<Toast key={'limit_node'}  show={show_toast_limit_node} onClose={()=>set_show_toast_limit_node(false)} autohide bg='warning' className='toastWarningLimitNode' style={{ 'position': 'absolute', 'marginTop': '300px', 'marginLeft': '250px', 'zIndex': 1 }}>
        <Toast.Header  closeButton={false}> <small className='me-auto'>Attention</small> </Toast.Header>
        <Toast.Body>Nombre limite de noeud atteint pour les utilisateurs non connecté</Toast.Body>
    </Toast>
    // Add Checkbox in preference menu to display the storytelling menu in menu configuration

    regular_ui['form'].push(SankeyViews.SankeyPlusMenuPreferenceView(data,set_data,preferenceCheck))
    regular_ui['form'].push(SankeyPlusMenuPreferenceLabels(t,data,set_data))

    if(has_sankeydev){
        regular_ui['mode']=SankeyDev_mode_Construction_Visualisation(data,set_data,mode_selection)
    }
    const elments_of_modale_preference=Object.values(regular_ui).map(d=>{
        return <>{d}<hr style={{ borderStyle: 'none', margin: '10px', color: 'grey', backgroundColor: 'grey', height: 1 }} /></>
    })

    const modale_preference=<React.Fragment key={'modale_preference'}><ModalPreference
        showPreference={showPreference}
        setShowPreference={setShowPreference}
        ui={elments_of_modale_preference}
    /></React.Fragment>

    const modalViewNotSaved=SankeyViews.modal_view_not_saved(view_not_saved,set_view_not_saved,t,current_data,set_current_data,data,set_data,view)

    external_menu_modal.push(modale_style_link)
    external_menu_modal.push(modale_style_node)
    external_menu_modal.push(modale_preference)
    external_menu_modal.push(toast_warning_limit_node)
    external_menu_modal.push(intro_modal)
    external_menu_modal.push(modalViewNotSaved)
    if(has_sankeydev){
        const publishImpl = (file_path:string) =>{
        // const form_data = new FormData()
        // form_data.append('file', input_file)

        const path = window.location.href

        const url = path + '/sankeydev/sankey/publish'

        const new_data = JSON.parse(JSON.stringify((current_data && view!=='none')?current_data:data))
        new_data.file_name = file_path

        const fetchData = {
            method: 'POST',
            body: JSON.stringify(new_data, null, 2)
        }

        fetch(url, fetchData).then( response => {
            if (!response.ok) {
            alert(response)
            }
        })
        set_show_publish_dialog(false)
        }

        const modale_publish=<PublishModal
        key={"publish"}
        t={t}
        show_publish_dialog={show_publish_dialog}
        set_show_publish_dialog={set_show_publish_dialog}
        publishImpl = {publishImpl}
        data = {data} />

        external_menu_modal.push(modale_publish)

    }

    const func_current_filter=(
        new_current_filter: number
    ) => {
        const { display_style } = data
        display_style.filter = +new_current_filter
        set_data({ ...data })
    }

    const opacity_advanced =  !window.SankeyToolsStatic ? '0.3' : '0'
    //Popover element to handle node levels (aggregation)
    let detail_level=
        <Popover id='popover-details-level' style={{maxWidth:'100%'}}>
        <Popover.Header as="h3">{t('Banner.ndd')}</Popover.Header>
        <Popover.Body style={{  marginLeft: '5px', width: '350px' }}>

            <table>{(Object.entries(data.nodeTags).filter(([, v]) => v.banner === 'level').length > 0) ? (<>
            {addSimpleLevelDropDown(t,data,set_data)}</>
            ) : (<>
            <Form.Control placeholder="Pas de filtrage" style={{ opacity: opacity_advanced, color: '#6c757d' }} disabled /></>)}</table>
        </Popover.Body>
        </Popover>
    if(has_open_sankey_plus){
        if ('Primaire' in data.nodeTags && data.nodeTags['Primaire'].activated === true) {
        Object.values(data.nodeTags).filter(tag_group=>tag_group.banner==='level').forEach(tag_group=>tag_group.activated = true)
        Object.values(data.nodeTags).filter(tag_group=>tag_group.banner==='level' ).forEach(tag_group=> {
            if (tag_group.siblings && tag_group.siblings.length > 0 && tag_group.activated ) {
            tag_group.siblings.forEach(sibling=>data.nodeTags[sibling].activated=false)
            }
        })
        if (Object.values(data.nodeTags).filter(tag_group=>tag_group.banner==='level').length > 1) {
            data.nodeTags['Primaire'].activated = false
        }
        }
        detail_level=
        <Popover id='popover-details-level' style={{maxWidth:'100%'}}>
        <Popover.Header as="h3">{t('Banner.ndd')}</Popover.Header>
        <Popover.Body style={{  marginLeft: '5px', width: '350px' }}>

            <table>{(Object.entries(data.nodeTags).filter(([, v]) => v.banner === 'level').length > 0) ? (<>
            {addAllDropDownNode(t,data,set_data,true)}</>
            ) : (<>
            <Form.Control placeholder="Pas de filtrage" style={{ opacity: opacity_advanced, color: '#6c757d' }} disabled /></>)}</table>
        </Popover.Body>
        </Popover>
    } else {
        Object.values(data.nodeTags).filter(tag_group=>tag_group.banner==='level').forEach(tag_group=>tag_group.activated = false)
        if ('Primaire' in data.nodeTags) {
        data.nodeTags['Primaire'].activated = true
        }
    }

    const {filter}=data.display_style
    const toolbar = toolbar_builder(
        t,data,set_data,mode_selection,user_scale,set_user_scale,filter,func_current_filter,
        detail_level,has_sankey_suite ? 'toto' :'',first_selected_node,set_first_selected_node,size_of_draw_zone,
        (current_data && current_data.view.length > 0) ? SankeyViews.setDiagram(set_current_data,set_view) : setDiagram,
        set_show_modal_welcome
    )

    if(!window.SankeyToolsStatic || (window.SankeyToolsStatic && data.view.length!==0)){
        toolbar.splice(0,0,SankeyViews.SankeyPlusBannerView(data,set_data,view,set_view,multi_selected_nodes,multi_selected_links,multi_selected_label,current_data,set_current_data,t,has_open_sankey_plus,set_view_not_saved))
    }
    if (has_sankey_suite) {
        const {units_names} = data
        let units = undefined
        if (units_names  && units_names.length > 0 && units_names[0].length > 0) {
            units = [units_names[0][0], 'Naturelles']
            toolbar.splice(1,0,additional_selector(data,set_data,units))
        }
    }
    const menu_banner=OpenSankeyMenuBanner(
        t,data,set_data,toolbar
    )

    // if(!window.SankeyToolsStatic){
    const formatKeyHandler=(e:KeyboardEvent)=>{
        SankeyViews.keyHandler(
            e,
            view==='none',
            current_data,
            set_current_data,
            data,
            set_data,
            view,
            set_view,
            set_animating,
            multi_selected_nodes,
            multi_selected_links,
            accordion_ref,button_ref,
            set_show_toast_new_view,
            set_show_toast_update_view,
            mode_selection,
            keyHandler,
            has_open_sankey_plus,
            size_of_draw_zone,
            set_view_not_saved
        )          
    }
    document.onkeydown = formatKeyHandler

    return (
        <div style={{ 'backgroundColor' : 'WhiteSmoke' }}>
        <>
        <Menu
            t={t}
            data={data}
            set_data={set_data}
            default_sankey_data={get_default_data}
            show_nav={show_nav}
            set_show_nav={set_show_nav}
            nav_item_active={nav_item_active}
            set_nav_item_active={set_nav_item_active}
            show_menu={true}
            callback={has_sankey_suite ? processTrade : ()=>null }
            path={path}
            launch={launch}
            url_prefix={ url_prefix }
            logo={!window.SankeyToolsStatic ? logo : window.sankey.logo as string}
            logo_terriflux={logo_terriflux}
            logo_width={!window.SankeyToolsStatic ? 100 : window.sankey.logo_width}
            app_name={'Version 1.0.0' }
            mode_selection={mode_selection}
            style_to_apply={style_to_apply}
            set_style_to_apply={set_style_to_apply}

            selected_node={selected_node}
            multi_selected_nodes={multi_selected_nodes}
            multi_selected_links={multi_selected_links}
            multi_selected_label={multi_selected_label}
            accordion_ref={accordion_ref}
            nodes_accordion_ref={nodes_accordion_ref}
            links_accordion_ref={links_accordion_ref}
            button_ref={button_ref}
            selected_link={selected_link}
            show_load={show_load}
            set_show_load={set_show_load}
            processing={processing}
            setProcessing={setProcessing}
            failure={failure}
            setFailure={setFailure}
            not_started={not_started}
            setNotStarted={setNotStarted}
            result={result}
            setResult={setResult}
            configurations_menus={configurations_menus}
            menus={sankey_menus}
            show_excel_dialog={show_excel_dialog}
            show_apply_layout={show_apply_layout}
            show_save_json={false}
            showPreference={showPreference}
            showStyleNode={showStyle}
            show_publish_dialog={show_publish_dialog}
            selected_style_node={selected_style_node}
            selected_style_link={selected_style_link}
            showStyleLink={showStyleLink}
            set_show_excel_dialog={set_show_excel_dialog}
            set_show_apply_layout={set_show_apply_layout}
            set_show_save_json={(b:boolean)=>{}}
            setShowPreference={setShowPreference}
            set_selected_style_link={set_selected_style_link}
            set_selected_style_node={set_selected_style_node}
            set_show_publish_dialog={set_show_publish_dialog}
            setShowStyleNode={setShowStyle}
            setShowStyleLink={setShowStyleLink}
            cardsTemplate={cardsTemplate}
            set_welcome_text={set_welcome_text}
            show_modalTemplate={show_modalTemplate}
            set_show_modalTemplate={set_show_modalTemplate}
            token={token}
            useNavigate={useNavigate}
            external_modal={external_menu_modal}
            menu_banner={menu_banner}
            loginOut={loginOut}
            unsetTokens={unsetTokens}
            min_width_and_height={size_of_draw_zone}
            set_user_scale={set_user_scale}
            name_user={name_user}
        />
        {/* New way to save the data, it save master data if the displayed sankey is a view or data if it's the master data */}
        <SankeySuiteDialogSaveJSON
            data={((current_data && view!=='none')?current_data:data)}
            set_data={set_data}
            show_save_json={show_save_json}
            set_show_save_json={set_show_save_json}
            t={t}
        />
        {has_open_sankey_plus && show_toast_new_view? SankeyViews.view_toast : null}
        {has_open_sankey_plus && show_toast_update_view? SankeyViews.view_toast_update_view : null}
        <Modal
            bsSize="large"
            show={welcome_text !== undefined && welcome_text !== ''}
            onHide={()=>{
            set_welcome_text('')
            }}
            style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
            }}>
            <Modal.Header closeButton>
            <Modal.Title>Lisez Moi</Modal.Title>
            </Modal.Header>
            <Modal.Body>
            {welcome_text ? parse(welcome_text) : ''}
            <Button
                onClick={()=>{
                set_welcome_text('')
                }}
            >J&apos;ai lu</Button>
            </Modal.Body>
        </Modal>
        { has_sankey_suite && show_split_trade_dialog ?  (
            <SplitVerticalModal
            data = {data}
            initial_trade_node_names = {(data as SuiteSankeyData).trade_sectors ? (data as SuiteSankeyData).trade_sectors : [] }
            set_show_split_trade = {set_show_split_trade_dialog} />
        ) :
            (<div/>)
        }
        {has_sankey_suite && show_reconciliation ? (
            <SupplyUseModelisationProd
            show_reconciliation={true}
            action_type={action_type}
            set_show_reconciliation={set_show_reconciliation}
            sankey_data={data}
            set_sankey_data={set_data}
            callback = {processTrade} />
        ) :
            (<div />)
        }
        </>
        </div>
    )

}
export default SankeySuiteMenu
